import TableRow from './table-row';

export default TableRow;